const getFormData = (
  event: React.FormEvent<HTMLFormElement>
): { [key: string]: FormDataEntryValue } => {
  const data = new FormData(event.currentTarget);
  return Object.fromEntries(data.entries());
};

export default getFormData;
